import { SEOHead } from '../components/common/SEOHead';
import { Breadcrumbs } from '../components/common/Breadcrumbs';
import { Link } from 'react-router-dom';

export const PrivacidadPage = () => {
  return (
    <>
      <SEOHead
        title="Política de Privacidad | REALimenta"
        description="Política de privacidad y protección de datos personales de REALimenta conforme al RGPD y LOPDGDD."
        canonical="/privacidad"
        noIndex={true}
      />

      <section className="pt-12 pb-20 md:pb-28">
        <div className="section-container">
          <Breadcrumbs items={[{ label: 'Política de Privacidad' }]} />

          <article className="max-w-3xl" data-testid="privacidad-content">
            <h1 className="font-manrope text-4xl sm:text-5xl font-extrabold text-text-primary tracking-tighter mb-8">
              Política de Privacidad
            </h1>

            <div className="prose prose-lg text-text-secondary space-y-8">

              {/* Responsable del Tratamiento */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  RESPONSABLE DEL TRATAMIENTO
                </h2>
                <ul className="list-none space-y-2 pl-0 bg-surface-secondary/30 p-6 rounded-xl">
                  <li><strong>Denominación social:</strong> FRANCISCO GONZALEZ TREJO</li>
                  <li><strong>Nombre comercial:</strong> REALIMENTA NATURAL VET</li>
                  <li><strong>DNI:</strong> 74856712S</li>
                  <li><strong>Domicilio:</strong> C/CAMINO VIEJO DE VELEZ 18. CP 29738. RINCON DE LA VICTORIA. MALAGA</li>
                  <li><strong>e-mail:</strong> REALIMENTA.NATURALVET@GMAIL.COM</li>
                </ul>
              </section>

              {/* Principios */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  PRINCIPIOS APLICADOS EN EL TRATAMIENTO DE DATOS
                </h2>
                <p>
                  En el tratamiento de sus datos personales, el Titular aplicará los siguientes principios que se ajustan a las exigencias del nuevo reglamento europeo de protección de datos (RGPD) y de la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD):
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <strong>Principio de licitud, lealtad y transparencia:</strong> El Titular siempre requerirá el consentimiento para el tratamiento de los datos personales que puede ser para uno o varios fines específicos sobre los que el Titular informará al Usuario previamente con absoluta transparencia.
                  </li>
                  <li>
                    <strong>Principio de minimización de datos:</strong> El Titular solicitará solo los datos estrictamente necesarios para el fin o los fines que los solicita.
                  </li>
                  <li>
                    <strong>Principio de limitación del plazo de conservación:</strong> El Titular mantendrá los datos personales recabados durante el tiempo estrictamente necesario para el fin o los fines del tratamiento. El Titular informará al Usuario del plazo de conservación correspondiente según la finalidad. En el caso de suscripciones, el Titular revisará periódicamente las listas y eliminará aquellos registros inactivos durante un tiempo considerable.
                  </li>
                  <li>
                    <strong>Principio de integridad y confidencialidad:</strong> Los datos personales recabados serán tratados de tal manera que su seguridad, confidencialidad e integridad esté garantizada. El Titular toma las precauciones necesarias para evitar el acceso no autorizado o uso indebido de los datos de sus usuarios por parte de terceros.
                  </li>
                </ul>
              </section>

              {/* Obtención de datos */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  OBTENCIÓN DE DATOS PERSONALES
                </h2>
                <p>
                  Para navegar por el sitio web no es necesario que facilite ningún dato personal. Los casos en los que usted sí proporciona sus datos personales son los siguientes:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Al contactar a través de los formularios de contacto o enviar un correo electrónico.</li>
                  <li>Al realizar un comentario en un artículo o página.</li>
                  <li>Al inscribirse en un formulario de suscripción o un boletín que el Titular gestiona con MailChimp.</li>
                  <li>Al inscribirse en un formulario de suscripción o un boletín que el Titular gestiona con MailerLite.</li>
                  <li>Al inscribirse en un formulario de suscripción o un boletín que el Titular gestiona con SendinBlue.</li>
                </ul>
              </section>

              {/* Derechos */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  SUS DERECHOS
                </h2>
                <p>
                  El Titular le informa que sobre sus datos personales tiene derecho a:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Solicitar el acceso a los datos almacenados.</li>
                  <li>Solicitar una rectificación o la cancelación.</li>
                  <li>Solicitar la limitación de su tratamiento.</li>
                  <li>Oponerse al tratamiento.</li>
                  <li>Solicitar la portabilidad de sus datos.</li>
                </ul>
                <p>
                  El ejercicio de estos derechos es personal y por tanto debe ser ejercido directamente por el interesado, solicitándolo directamente al Titular, lo que significa que cualquier cliente, suscriptor o colaborador que haya facilitado sus datos en algún momento, puede dirigirse al Titular y pedir información sobre los datos que tiene almacenados y cómo los ha obtenido, solicitar la rectificación de los mismos, solicitar la portabilidad de sus datos personales, oponerse al tratamiento, limitar su uso o solicitar la cancelación de esos datos en los ficheros del Titular.
                </p>
                <p className="bg-surface-secondary/30 p-4 rounded-xl mt-4">
                  Para ejercitar sus derechos de acceso, rectificación, cancelación, portabilidad y oposición tiene que enviar un correo electrónico a{' '}
                  <a 
                    href="mailto:REALIMENTA.NATURALVET@GMAIL.COM" 
                    className="text-brand-primary hover:underline font-medium"
                  >
                    REALIMENTA.NATURALVET@GMAIL.COM
                  </a>{' '}
                  junto con la prueba válida en derecho como una fotocopia del D.N.I. o equivalente.
                </p>
                <p>
                  Tiene derecho a la tutela judicial efectiva y a presentar una reclamación ante la autoridad de control, en este caso, la Agencia Española de Protección de Datos, si considera que el tratamiento de datos personales que le conciernen infringe el Reglamento.
                </p>
              </section>

              {/* Finalidad del tratamiento */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  FINALIDAD DEL TRATAMIENTO DE DATOS PERSONALES
                </h2>
                <p>
                  Cuando usted se conecta al sitio web para mandar un correo al Titular, se suscribe a su boletín o realiza una contratación, está facilitando información de carácter personal de la que el responsable es el Titular. Esta información puede incluir datos de carácter personal como pueden ser su dirección IP, nombre y apellidos, dirección física, dirección de correo electrónico, número de teléfono, y otra información. Al facilitar esta información, da su consentimiento para que su información sea recopilada, utilizada, gestionada y almacenada por el Titular, sólo como se describe en el Aviso Legal y en la presente Política de Privacidad.
                </p>
                <p>
                  Los datos personales y la finalidad del tratamiento por parte del Titular es diferente según el sistema de captura de información:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <strong>Formularios de contacto:</strong> El Titular solicita datos personales entre los que pueden estar: Nombre y apellidos, dirección de correo electrónico, número de teléfono y dirección de sitio web con la finalidad de responder a las consultas de los Usuarios.
                  </li>
                  <li>
                    <strong>Formularios de suscripción a contenidos:</strong> El Titular solicita los siguientes datos personales: nombre y apellidos, dirección de correo electrónico, número de teléfono y dirección del sitio web para gestionar la lista de suscripciones, enviar boletines, promociones y ofertas especiales.
                  </li>
                  <li>
                    <strong>Formularios de suscripción a comentarios:</strong> El Titular solicita los siguientes datos personales: nombre y apellidos, dirección de correo electrónico y dirección del sitio web para realizar la suscripción a los comentarios de una publicación determinada y recibir notificaciones cuando un usuario responda a su comentario.
                  </li>
                </ul>
                <p>
                  Existen otras finalidades por las que el Titular trata datos personales:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Para garantizar el cumplimiento de las condiciones recogidas en el Aviso Legal y en la ley aplicable. Esto puede incluir el desarrollo de herramientas y algoritmos que ayuden a este sitio web a garantizar la confidencialidad de los datos personales que recoge.</li>
                  <li>Para apoyar y mejorar los servicios que ofrece este sitio web.</li>
                  <li>Para analizar la navegación. El Titular recoge otros datos no identificativos que se obtienen mediante el uso de cookies que se descargan en el ordenador del usuario cuando navega por el sitio web cuyas características y finalidad están detalladas en la Política de Cookies.</li>
                  <li>Para gestionar las redes sociales. El Titular tiene presencia en redes sociales. Si usted se hace seguidor en las redes sociales del Titular el tratamiento de los datos personales se regirá por este apartado, así como por aquellas condiciones de uso, políticas de privacidad y normativas de acceso que pertenezcan a la red social que proceda en cada caso y que ha aceptado previamente.</li>
                </ul>
              </section>

              {/* Seguridad */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  SEGURIDAD DE LOS DATOS PERSONALES
                </h2>
                <p>
                  Para proteger sus datos personales, el Titular toma todas las precauciones razonables y sigue las mejores prácticas de la industria para evitar su pérdida, mal uso, acceso indebido, divulgación, alteración o destrucción de los mismos.
                </p>
                <p>
                  El sitio web está alojado en un servidor seguro. Los datos personales facilitados se encuentran protegidos con tecnología SSL (Secure Socket Layer) para garantizar la privacidad de las comunicaciones.
                </p>
              </section>

              {/* Contenido de otros sitios */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  CONTENIDO DE OTROS SITIOS WEB
                </h2>
                <p>
                  Las páginas de este sitio web pueden incluir contenido incrustado (por ejemplo, vídeos, imágenes, artículos, etc.). El contenido incrustado de otras webs se comporta exactamente de la misma manera que si el visitante hubiera visitado la otra web.
                </p>
                <p>
                  Estos sitios web pueden recopilar datos sobre usted, utilizar cookies, incrustar un seguimiento adicional de terceros, y supervisar su interacción con ese contenido incrustado, incluido el seguimiento de su interacción con el contenido incrustado si tiene una cuenta y está conectado a esa web.
                </p>
              </section>

              {/* Política de Cookies */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  POLÍTICA DE COOKIES
                </h2>
                <p>
                  Para que este sitio web funcione correctamente necesita utilizar cookies, que es una información que se almacena en su navegador web.
                </p>
                <p>
                  En la página{' '}
                  <Link to="/politica-cookies" className="text-brand-primary hover:underline font-medium">
                    Política de Cookies
                  </Link>{' '}
                  puede consultar toda la información relativa a la política de recogida, la finalidad y el tratamiento de las cookies.
                </p>
              </section>

              {/* Legitimación */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  LEGITIMACIÓN PARA EL TRATAMIENTO DE DATOS
                </h2>
                <p>
                  La base legal para el tratamiento de sus datos es: el consentimiento.
                </p>
                <p>
                  Para contactar con el Titular, suscribirse a un boletín o realizar comentarios en este sitio web tiene que aceptar la presente Política de Privacidad.
                </p>
              </section>

              {/* Categorías de datos */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  CATEGORÍAS DE DATOS PERSONALES
                </h2>
                <p>
                  Las categorías de datos personales que trata el Titular son:
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Datos identificativos.</li>
                  <li>Datos relativos a tu mascota (tipo, nombre, edad, peso, estado de salud).</li>
                </ul>
              </section>

              {/* Conservación */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  CONSERVACIÓN DE DATOS PERSONALES
                </h2>
                <p>
                  Los datos personales que proporcione al Titular se conservarán hasta que solicite su supresión.
                </p>
              </section>

              {/* Destinatarios */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  DESTINATARIOS DE DATOS PERSONALES
                </h2>
                <p>
                  El Titular informa que puede facilitar sus datos personales a terceros encargados del tratamiento para dar cumplimiento al compromiso contractual.
                </p>
              </section>

              {/* Navegación Web */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  NAVEGACIÓN WEB
                </h2>
                <p>
                  Al navegar por el sitio web se pueden recoger datos no identificativos, que pueden incluir, la dirección IP, geolocalización, un registro de cómo se utilizan los servicios y sitios, hábitos de navegación y otros datos que no pueden ser utilizados para identificarle.
                </p>
                <p>
                  El sitio web utiliza los siguientes servicios de análisis de terceros:
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>PostHog</li>
                </ul>
                <p>
                  El Titular utiliza la información obtenida para obtener datos estadísticos, analizar tendencias, administrar el sitio, estudiar patrones de navegación y para recopilar información demográfica.
                </p>
              </section>

              {/* Exactitud y veracidad */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  EXACTITUD Y VERACIDAD DE LOS DATOS PERSONALES
                </h2>
                <p>
                  Usted se compromete a que los datos facilitados al Titular sean correctos, completos, exactos y vigentes, así como a mantenerlos debidamente actualizados.
                </p>
                <p>
                  Como Usuario del sitio web es el único responsable de la veracidad y corrección de los datos que remita al sitio exonerando al Titular de cualquier responsabilidad al respecto.
                </p>
              </section>

              {/* Aceptación */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  ACEPTACIÓN Y CONSENTIMIENTO
                </h2>
                <p>
                  Como Usuario del sitio web declara haber sido informado de las condiciones sobre protección de datos de carácter personal, acepta y consiente el tratamiento de los mismos por parte del Titular en la forma y para las finalidades indicadas en esta Política de Privacidad.
                </p>
              </section>

              {/* Revocabilidad */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  REVOCABILIDAD
                </h2>
                <p>
                  Para ejercitar sus derechos de acceso, rectificación, cancelación, portabilidad y oposición tiene que enviar un correo electrónico a{' '}
                  <a 
                    href="mailto:REALIMENTA.NATURALVET@GMAIL.COM" 
                    className="text-brand-primary hover:underline font-medium"
                  >
                    REALIMENTA.NATURALVET@GMAIL.COM
                  </a>{' '}
                  junto con la prueba válida en derecho como una fotocopia del D.N.I. o equivalente.
                </p>
                <p>
                  El ejercicio de sus derechos no incluye ningún dato que el Titular esté obligado a conservar con fines administrativos, legales o de seguridad.
                </p>
              </section>

              {/* Cambios */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  CAMBIOS EN LA POLÍTICA DE PRIVACIDAD
                </h2>
                <p>
                  El Titular se reserva el derecho a modificar la presente Política de Privacidad para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria.
                </p>
                <p>
                  Estas políticas estarán vigentes hasta que sean modificadas por otras debidamente publicadas.
                </p>
              </section>

              {/* Última actualización */}
              <p className="text-sm text-text-muted pt-8 border-t border-border-primary">
                Última actualización: Enero 2026
              </p>

            </div>
          </article>
        </div>
      </section>
    </>
  );
};

export default PrivacidadPage;
